import axios from "axios";
import React, { useEffect, useState } from "react";
import StickyTable from "../../components/common/StickyTable";
import { ROLE_LIST, ROLE_DELETE } from "../../routes/routes";
import { PAGINATE, ROLE_DELETED } from "../../constant/constant";
import { toast } from "react-toastify";
import {
  NoDataFound,
  Pagination,
  checkEmptyOrNull,
} from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";

const RoleList = () => {
  const { hasPermission } = usePermission();
  // ## State Variable Declaration
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false); // New state to trigger refresh
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [detailsModal, setDetailModal] = useState(false);

  /**
   * @API Cateogry List API's call
   */
  const navigate = useNavigate();

  const HandleDelete = async (RoleId) => {
    try {
      axios
        .delete(ROLE_DELETE + RoleId)
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            toast.success(ROLE_DELETED);
            setRefresh((prevRefresh) => !prevRefresh);
            navigate("/roles");
          }
        })
        .catch((err) => {
          if (err.response.status === 422) {
            toast.error(err.response.data.msg);
          }
        });
    } catch (error) {
      // Handle errors
      console.error(error);
    }
  };

  useEffect(() => {
    axios
      .get(ROLE_LIST + `?type=${PAGINATE}&page=${page}`)
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.roles);
          setPaginator({
            prev: response.data.data.prev_page_url != null,
            next: response.data.data.next_page_url != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .finally(() => {
        setLoading(false); // Set loading to false after data is fetched
      });
  }, [page, refresh, perPage]);

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Roles</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Roles List</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                {hasPermission("roles-create") && (
                  <Link to={"/create/role"}>
                    <button
                      type="button"
                      className="btn rounded-pill btn-primary ibutton"
                    >
                      <span className="tf-icons bx bx-plus"></span>&nbsp; Add
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
          <div className="card-header">
            <h5>Roles List</h5>
            {/* <Link to={"/create/role"}>
              <button type="button" className="btn rounded-pill btn-primary ibutton">
                <span className="tf-icons bx bx-plus"></span>&nbsp; Add
              </button>
            </Link> */}
          </div>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
          <StickyTable refreshDeps={[data, loading]}><table className="table table-striped itable">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>Role Name</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="3" />
                ) : data.length > 0 ? (
                  data.map((role, i) => (
                    <tr key={i}>
                      <td>{role?.sno}</td>
                      <td>{role?.name}</td>
                      <td style={{ textAlign: "right" }}>
                        {hasPermission("roles-list") && (
                          <button
                            className="badge bg-label-info me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="View"
                            data-bs-original-title="View"
                            onClick={() => {
                              setDetailModal(true);
                              setDetailData(role);
                            }}
                          >
                            <i className="bx bx-show"></i>
                          </button>
                        )}

                        {hasPermission("roles-edit") && (
                          <Link to={`/role/${role.id}/edit`}>
                            <button
                              className="badge bg-label-success me-1 border-0"
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="Edit"
                              data-bs-original-title="Edit"
                            >
                              <i className="bx bx-pencil"></i>
                            </button>
                          </Link>
                        )}

                        {/* <button
                            onClick={() => {
                              setConfirmationModal(true);
                              setConfirmation({
                                message:
                                  "Are you sure, you want to delete?",
                                fn: () => HandleDelete(role?.id),
                              });
                            }}
                            className="badge bg-label-danger me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Delete"
                            data-bs-original-title="Delete"
                          >
                            <i className="bx bx-trash"></i>
                          </button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="3" message="No Data Found" />
                )}
              </tbody>
            </table>
          </StickyTable>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#1A4331"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                confirmation.fn();
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={detailsModal}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Role & Permissions Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-4">
                  <label className="form-label m-0">Role Name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.name)}
                  </span>
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label mb-2">Permissions</label>
                  <div className="d-flex flex-wrap gap-2">
                    {Array.isArray(detailData?.permissions) &&
                    detailData.permissions.length > 0 ? (
                      detailData.permissions.map((p, i) => {
                        const parts = p.split(" - ");
                        const displayText =
                          parts.length === 2
                            ? `${parts[1]} - ${parts[0].toUpperCase()}`
                            : p;
                        return (
                          <span
                            key={i}
                            className="badge px-3 py-2"
                            style={{
                              fontSize: "0.875rem",
                              borderRadius: "8px",
                              backgroundColor: "#F6E9EA",
                              color: "#1A4331",
                              border: "1px solid #dfcfcf",
                            }}
                          >
                            {displayText}
                          </span>
                        );
                      })
                    ) : (
                      <span className="text-muted">
                        No permissions assigned
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RoleList;
